__turbopack_context__.v({
  "inputError": "InputPhone-module-scss-module__m5y67W__inputError",
  "inputLabel": "InputPhone-module-scss-module__m5y67W__inputLabel",
  "inputPhone": "InputPhone-module-scss-module__m5y67W__inputPhone",
});
